import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardProvidersComponent } from './dashboard-providers.component';
import { DashboardProvidersRoutingModule } from './dashboard-providers-routing.module';
import { DocumentsVerifyModule } from '../documents-verify/documents-verify.module';
import { Trip2ThemeModule } from '../../trip2-theme/trip2-theme.module';
import { FormsModule } from '@angular/forms';
import { ComunicationDashboard } from './comunication-dashboard';
import { MessagesComponent } from './components/messages/messages.component';
import { MessageService } from 'app/core/services/message.service';

@NgModule({
  imports: [
    CommonModule,
    DashboardProvidersRoutingModule,
    DocumentsVerifyModule,
    // ProvidersBillingModule,
    Trip2ThemeModule,
    FormsModule
  ],
  declarations: [
    DashboardProvidersComponent,
    MessagesComponent
  ],
  providers: [
    ComunicationDashboard,
    MessageService
  ],
  exports: [
    DashboardProvidersComponent
  ]
})
export class DashboardProvidersModule { }



// WEBPACK FOOTER //
// ./src/app/pages/dashboard-providers/dashboard-providers.module.ts